import { config } from './config';

export async function fetchData(properties) {
    try {
        const response = await fetch(properties.url + properties.functionName, {
             method: properties.mode,
            // credentials: "include",
             headers: {
                "Content-Type": "application/json",
            },
            body: properties.body
        });
        if (!response.ok) {
            throw Error(response.statusText);
        }
        
        let data = await response.json();

        return data;
    } catch (error) {
        console.log(error);
    }
}

export function createDbExecute(cnn, proc, json) {
    return {
        ProcName: proc,
        Cnn: cnn,
        Parameters: json
    };
}

export async function callFetchData(DBExecute) {
    let url = config.Url.BASIC_API;
    let res = [];

    await fetchData({
        mode: "POST",
        url: url,
        functionName: DBExecute.functionName !== undefined ? DBExecute.functionName : config.Controllers.GetJson,
        body: JSON.stringify(DBExecute)
    }).then(result => {
        // return Success(result);
        res = result;
    });
    return res;
}

export const fetchGushimList = async () => {
    const DBExecute = createDbExecute(config.Connections.Cnn_GisYk, 242700424, {});
    let gushimRes;

    await callFetchData(DBExecute)
        .then(result => {
            gushimRes = result;
        })
        .catch(err => {
            console.log('fetchGushimList error: ', err);
            gushimRes = [];
        })
        
    return gushimRes;
}

export const fetchStreetsList = async () => {
    const DBExecute = createDbExecute(config.Connections.Cnn_GisYk, 242700426, {});
    let streetsRes;

    await callFetchData(DBExecute)
        .then(result => {
            streetsRes = result;
        })
        .catch(err => {
            console.log('fetchStreetsList error: ', err);
            streetsRes = [];
        })
        
    return streetsRes;
}

export const fetchTabasList = async (sysCode) => {
    const DBExecute = createDbExecute(config.Connections.Cnn_GisYk, 242700427, { systemCode: sysCode });
    let tabaRes;

    await callFetchData(DBExecute)
        .then(result => {
            tabaRes = result;
        })
        .catch(err => {
            console.log('fetchTabaList error: ', err);
            tabaRes = [];
        })
        
    return tabaRes;
}

export const fetchHelkotByGushId = async (misparGush) => { 
    const DBExecute = createDbExecute(config.Connections.Cnn_GisYk, 242700425, { gushId: misparGush });
    let helkotRes;

    await callFetchData(DBExecute)
        .then(result => {
            helkotRes = result;
        })
        .catch(err => {
            console.log('fetchHelkotByGushId error: ', err);
            helkotRes = [];
        })
        
    return helkotRes;
}

export const fetchTikRushiData = async (paramsToSerach) => {
    const DBExecute = createDbExecute(config.Connections.Cnn_GisYk, 242700437, { 
        misparTik: paramsToSerach.misparTik,
        gush: paramsToSerach.gush,
        helka: paramsToSerach.helka,
        rehovCode: paramsToSerach.rehovCode,
        mispBait: paramsToSerach.mispBait,
        mezahe: paramsToSerach.mezahe,
        migrash: paramsToSerach.migrash,
        systemId: paramsToSerach.systemId
    });

    let tikRushiRes

    await callFetchData(DBExecute)
        .then(result => {
            tikRushiRes = result;
        })
        .catch(err => {
            console.log('fetchTikRushiData error: ', err);
            tikRushiRes = [];
        })
        
    return tikRushiRes;
}

//Teur Habakasha:
export const getTeurHabakashaContentData = async (tikNum, systemCode) => {
    const DBExecute = createDbExecute(config.Connections.Cnn_GisYk, 242700447, { 
        tikNum: tikNum,
        systemCode: systemCode
    });

    let teurHabakashaRes;

    await callFetchData(DBExecute)
        .then(result => {
            teurHabakashaRes = result[0];
        })
        .catch(err => {
            console.log('getTeurHabakashaContentData error: ', err);
            teurHabakashaRes = [];
        })
    
    return teurHabakashaRes;
}

//Process:
export const getProcessesTitleData = async (tikNum, systemCode) => {
    const DBExecute = createDbExecute(config.Connections.Cnn_GisYk, 242700448, { 
        SystemID: systemCode,
        TikNum: tikNum
    });

    let processesTitleRes;

    await callFetchData(DBExecute)
        .then(result => {
            processesTitleRes = result;
        })
        .catch(err => {
            console.log('getProcessesTitleData error: ', err);
            processesTitleRes = [];
        })
    
    return processesTitleRes;
}

export const getProcessesContentData = async (systemCode, tikNum, processCode) => {
    const DBExecute = createDbExecute(config.Connections.Cnn_GisYk, 242700451, { 
        SystemID: systemCode,
        TikNum: tikNum,
        // processCode: processCode
    });

    let processesContentRes;

    await callFetchData(DBExecute)
        .then(result => {
            processesContentRes = result;
        })
        .catch(err => {
            console.log('getProcessesContentData error: ', err);
            processesContentRes = [];
        })
    
    return processesContentRes;
}

//Hahlatot Vahada:
export const getHahlatotContentData = async (systemCode, tikNum) => {
    const DBExecute = createDbExecute(config.Connections.Cnn_GisYk, 242700453, { 
        systemID: systemCode,
        tikNum: tikNum
    });

    let hahlatotRes;
    await callFetchData(DBExecute)
    .then(result => {
        hahlatotRes = result;
    })
    .catch(err => {
        console.log('getHahlatotContentData error: ', err);
        hahlatotRes = [];
    })

    return hahlatotRes;
}

//Location:
export const getKtovetContentData = async(systemCode, tikNum) => {
    const DBExecute = createDbExecute(config.Connections.Cnn_GisYk, 242700455, { 
        systemId: systemCode,
        tikNum: tikNum
    });

    let ktovetRes;
    await callFetchData(DBExecute)
    .then(result => {
        ktovetRes = result[0];
    })
    .catch(err => {
        console.log('getKtovetContentData error: ', err);
        ktovetRes = [];
    })

    return ktovetRes;
}

export const getGushimVeHelkotContentData = async(systemCode, tikNum) => {
    const DBExecute = createDbExecute(config.Connections.Cnn_GisYk, 242700456, { 
        SystemId: systemCode,
        TikNum: tikNum
    });

    let gushimRes;
    await callFetchData(DBExecute)
    .then(result => {
        gushimRes = result;
    })
    .catch(err => {
        console.log('getGushimContentData error: ', err);
        gushimRes = [];
    })

    return gushimRes;
}

export const getMigrashimContentData = async(systemCode, tikNum) => {
    const DBExecute = createDbExecute(config.Connections.Cnn_GisYk, 242700457, { 
        systemID: systemCode,
        tikNum: tikNum
    });

    let migrashimRes;
    await callFetchData(DBExecute)
    .then(result => {
        migrashimRes = result;
    })
    .catch(err => {
        console.log('getHahlatotContentData error: ', err);
        migrashimRes = [];
    })

    return migrashimRes;
}

//Areas:
export const getSqrContentData = async(systemCode, tikNum) => {
    const DBExecute = createDbExecute(config.Connections.Cnn_GisYk, 242700454, { 
        SystemId: systemCode,
        TikNum: tikNum
    });

    let sqrRes;
    await callFetchData(DBExecute)
    .then(result => {
        sqrRes = result;
    })
    .catch(err => {
        console.log('getSqrContentData error: ', err);
        sqrRes = [];
    })

    return sqrRes;
}

//Tnaim:
export const getTnaimTitleData =  async (tikNum) => {
    const DBExecute = createDbExecute(config.Connections.Cnn_GisYk, 242700449, { 
        TikNum: tikNum
    });

    let tnaimTitleRes;

    await callFetchData(DBExecute)
        .then(result => {
            tnaimTitleRes = result;
        })
        .catch(err => {
            console.log('getTnaimTitleData error: ', err);
            tnaimTitleRes = [];
        })
    
    return tnaimTitleRes;
}

export const getTnaimContentData =  async (tikNum) => {
    const DBExecute = createDbExecute(config.Connections.Cnn_GisYk, 242700450, { 
        TikNum: tikNum
    });

    let tnaimContentRes;

    await callFetchData(DBExecute)
        .then(result => {
            tnaimContentRes = result;
        })
        .catch(err => {
            console.log('getTnaimContentData error: ', err);
            tnaimContentRes = [];
        })
    
    return tnaimContentRes;
}

//Archiv
export const getArchivContentData =  async (systemCode, tikNum) => {
    let combKeyNumber = systemCode !== "26400056" ? 242700452 : 242700571
    const DBExecute = createDbExecute(config.Connections.Cnn_GisYk, combKeyNumber, { 
        sysId: systemCode,
        tikNum: tikNum
    });

    let archivRes;

    await callFetchData(DBExecute)
        .then(result => {
            archivRes = result;
        })
        .catch(err => {
            console.log('getArchivContentData error: ', err);
            archivRes = [];
        })
    
    return archivRes;
}

/* TABA */
export const fetchTikTabaData = async (paramsToSerach) => {
    const DBExecute = createDbExecute(config.Connections.Cnn_GisYk, 242700470, { 
        misparTaba: paramsToSerach.misparTaba,
        gush: paramsToSerach.gush,
        helka: paramsToSerach.helka,
        rehovCode: paramsToSerach.rehovCode,
        mispBait: paramsToSerach.mispBait
    });

    let tikTabaRes

    await callFetchData(DBExecute)
        .then(result => {
            tikTabaRes = result;
        })
        .catch(err => {
            console.log('fetchTikTabaData error: ', err);
            tikTabaRes = [];
        })
        
    return tikTabaRes;
}
//Tamztit Taba: 
export const fetchTabaTamztitTabaData = async (tikTabaNum) => {
    const DBExecute = createDbExecute(config.Connections.Cnn_GisYk, 242700464, { 
        tikTabaNum: tikTabaNum
    });

    let tabaTamztitTabaRes

    await callFetchData(DBExecute)
        .then(result => {
            tabaTamztitTabaRes = result[0];
        })
        .catch(err => {
            console.log('fetchTabaTamztitTabaData error: ', err);
            tabaTamztitTabaRes = [];
        })
        
    return tabaTamztitTabaRes;
}

//Taba Teur Tochnit:
export const fetchTabaTeurTochnitData = async (tikTabaNum) => {
    const DBExecute = createDbExecute(config.Connections.Cnn_GisYk, 242700466, { 
        tikNum: tikTabaNum
    });

    let tabaTeurTochnitRes

    await callFetchData(DBExecute)
        .then(result => {
            tabaTeurTochnitRes = result[0];
        })
        .catch(err => {
            console.log('fetchTabaTeurTochnitData error: ', err);
            tabaTeurTochnitRes = [];
        })
        
    return tabaTeurTochnitRes;
}

//Taba Havot Daat:
export const fetchTabaHavotDaatData = async (systemCode, tikTabaNum) => {
    const DBExecute = createDbExecute(config.Connections.Cnn_GisYk, 242700468, { 
        tikNum: tikTabaNum,
        systemCode: systemCode //26400001
    });

    let tabaHavotDaatRes

    await callFetchData(DBExecute)
        .then(result => {
            tabaHavotDaatRes = result;
        })
        .catch(err => {
            console.log('fetchTabaHavotDaatData error: ', err);
            tabaHavotDaatRes = [];
        })
        
    return tabaHavotDaatRes;
}

//Taba Yahas Tohnit:
export const fetchTabaYahasTohnitData = async (tikTabaNum) => {
    const DBExecute = createDbExecute(config.Connections.Cnn_GisYk, 242700467, { 
        tikNum: tikTabaNum
    });

    let tabaYahasTohnitRes

    await callFetchData(DBExecute)
        .then(result => {
            tabaYahasTohnitRes = result;
        })
        .catch(err => {
            console.log('fetchTabaYahasTohnitData error: ', err);
            tabaYahasTohnitRes = [];
        })
        
    return tabaYahasTohnitRes;
}

//Pikuah Bnia:
export const fetchTikPikuahBniaData = async (paramsToSerach) => {
    const DBExecute = createDbExecute(config.Connections.Cnn_GisYk, 242700474, { 
        mispartikPikuah: paramsToSerach.misparTik,
        gush: paramsToSerach.gush,
        helka: paramsToSerach.helka,
        rehovCode: paramsToSerach.rehovCode,
        mispBait: paramsToSerach.mispBait,
        mezahe: paramsToSerach.mezahe,
        migrash: paramsToSerach.migrash
        // ,systemId: paramsToSerach.systemId
    });

    let tikPikuahBniaRes

    await callFetchData(DBExecute)
        .then(result => {
            tikPikuahBniaRes = result;
        })
        .catch(err => {
            console.log('fetchTikPikuahBniaData error: ', err);
            tikPikuahBniaRes = [];
        })
        
    return tikPikuahBniaRes;
}

export const getTikPikuahType = async (tikNum) => {
    const DBExecute = createDbExecute(config.Connections.Cnn_GisYk, 242700471, { 
        tikNum: tikNum
    });

    let pikuahTypeRes;

    await callFetchData(DBExecute)
        .then(result => {
            pikuahTypeRes = result;
        })
        .catch(err => {
            console.log('getTikPikuahType error: ', err);
            pikuahTypeRes = [];
        })
    
    return pikuahTypeRes;
}

export const getProcessesTitlePikuahBniaData = async (tikNum) => {
    const DBExecute = createDbExecute(config.Connections.Cnn_GisYk, 242700475, { 
        TikNum: tikNum
    });

    let processesTitlePikuahBniaRes;

    await callFetchData(DBExecute)
        .then(result => {
            processesTitlePikuahBniaRes = result;
        })
        .catch(err => {
            console.log('getProcessesTitlePikuahBniaData error: ', err);
            processesTitlePikuahBniaRes = [];
        })
    
    return processesTitlePikuahBniaRes;
}

export const getProcessesContentPikuahBniaData = async (tikNum) => {
    const DBExecute = createDbExecute(config.Connections.Cnn_GisYk, 242700473, { 
        TikNum: tikNum
    });

    let processesPikuahBniaRes;

    await callFetchData(DBExecute)
        .then(result => {
            processesPikuahBniaRes = result;
        })
        .catch(err => {
            console.log('getProcessesContentPikuahBniaData error: ', err);
            processesPikuahBniaRes = [];
        })
    
    return processesPikuahBniaRes;
}

export const getTikPikuahEshurim = async (tikNum) => {
    const DBExecute = createDbExecute(config.Connections.Cnn_GisYk, 242700472, { 
        tikNum: tikNum
    });

    let pikuahEshurimRes;

    await callFetchData(DBExecute)
        .then(result => {
            pikuahEshurimRes = result;
        })
        .catch(err => {
            console.log('getTikPikuahEshurim error: ', err);
            pikuahEshurimRes = [];
        })
    
    return pikuahEshurimRes;
}

//Heytel Hashbaha:
export const fetchTikHeytelHashbahaData = async (paramsToSerach) => {
    const DBExecute = createDbExecute(config.Connections.Cnn_GisYk, 242700479, { 
        misparTik: paramsToSerach.misparTik,
        asmahtaNum: paramsToSerach.asmahtaNum,
        tofesInternetNum: paramsToSerach.tofesInternetNum
    });

    let tikHeytelRes

    await callFetchData(DBExecute)
        .then(result => {
            tikHeytelRes = result[0];
        })
        .catch(err => {
            console.log('fetchTikHeytelHashbahaData error: ', err);
            tikHeytelRes = [];
        })
        
    return tikHeytelRes;
}

export const getHeytelHashbahaProcessData = async (tikNum) => {
    const DBExecute = createDbExecute(config.Connections.Cnn_GisYk, 242700480, { 
        tikNum: tikNum
    });

    let heytelProcessesRes;

    await callFetchData(DBExecute)
        .then(result => {
            heytelProcessesRes = result;
        })
        .catch(err => {
            console.log('getHeytelHashbahaProcessData error: ', err);
            heytelProcessesRes = [];
        })
    
    return heytelProcessesRes;
}